"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASS_SCALE = exports.CLASS_SEARCH_OPEN = exports.CLASS_SOLR_SUGGESTION_LINK = exports.CLASS_FILLED = exports.CLASS_OPACITY_0 = exports.CLASS_ROTATING = exports.CLASS_INVALID = exports.CLASS_NAVBAR_OPEN = exports.CLASS_COLLAPSED = exports.CLASS_SHOW = exports.CLASS_SCROLLED = exports.CLASS_ACTIVE = exports.CLASS_D_NONE = exports.CLASS_STICKY = exports.CLASS_COUNTED = exports.CLASS_COUNTING = exports.CLASS_HIDDEN = exports.CLASS_OPEN = void 0;
exports.CLASS_OPEN = 'is-open';
exports.CLASS_HIDDEN = 'is-hidden';
exports.CLASS_COUNTING = 'is-counting';
exports.CLASS_COUNTED = 'is-counted';
exports.CLASS_STICKY = 'is-sticky';
exports.CLASS_D_NONE = 'd-none';
exports.CLASS_ACTIVE = 'is-active';
exports.CLASS_SCROLLED = 'scrolled';
exports.CLASS_SHOW = 'show';
exports.CLASS_COLLAPSED = 'collapsed';
exports.CLASS_NAVBAR_OPEN = 'navbar-open';
exports.CLASS_INVALID = 'is-invalid';
exports.CLASS_ROTATING = 'is-rotating';
exports.CLASS_OPACITY_0 = 'opacity-0';
exports.CLASS_FILLED = 'is-filled';
exports.CLASS_SOLR_SUGGESTION_LINK = 'tx-solr-suggestion-link';
exports.CLASS_SEARCH_OPEN = 'search-open';
exports.CLASS_SCALE = 'scaled';
